/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { FadeInOutView, Text } from "UpduoLibrary";
import {
  colorWithOpacity,
  skaleBlack,
  upduoPrimaryBlack,
} from "config/UpduoColors";

interface TimeWindowIntroModalProps {
  isVisible: boolean;
}

export default function TimeWindowIntroModal({
  isVisible,
}: TimeWindowIntroModalProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <FadeInOutView
      style={{
        backgroundColor: "white",
        shadowColor: colorWithOpacity(skaleBlack, 0.25),
        shadowRadius: 6,
        position: "absolute",
        bottom: "100%",
        marginBottom: 8,
        borderRadius: 8,
        width: 386,
        padding: 12,
      }}
    >
      <Text
        style={{
          fontSize: 16,
          color: upduoPrimaryBlack,
          lineHeight: 22,
          textAlign: "center",
        }}
      >
        <Text style={{ fontWeight: "bold" }}>
          {"Time Windows for Matching \n"}
        </Text>
        <Text>
          {
            "Time windows are meant to improve matching within an organization by setting an expected time frame each day for users to hop into Upduo sessions"
          }
        </Text>
      </Text>
    </FadeInOutView>
  );
}
